import React from 'react';
import './css/about.css';
import Lottie from 'lottie-react';
import aboutAnimation from './lotties/94115-reading-boy.json';
import { useState } from 'react';

export default function About() {
  const [value, setValue] = useState('education');

  const handleClick = (val) => {
    setValue(val);
  };

  return (
    <div className="about container " id="about">
      <div className="container-fluid">
        <h1 className="aboutTitle">About</h1>
        <div className="row ">
          <div className="details col-sm-7">
            {/* <div className="clickToKnowAboutn ">
              
            </div> */}
            <table className="table">
              <thead className="nav-item table-head">
                <th
                  scope="col"
                  type="button"
                  // className=" p-3"
                  className={`p-2 ${value === 'education' ? 'active' : ''}`}
                  onClick={() => {
                    handleClick('education');
                  }}
                >
                  Education
                </th>
                <th
                  scope="col"
                  type="button"
                  // className="p-3"
                  className={`p-2 ${value === 'experience' ? 'active' : ''}`}
                  onClick={() => {
                    handleClick('experience');
                  }}
                >
                  Experience
                </th>
                <th
                  scope="col"
                  type="button"
                  // className="p-3"
                  className={`p-2 ${value === 'achievements' ? 'active' : ''}`}
                  onClick={() => {
                    handleClick('achievements');
                  }}
                >
                  Achievements
                </th>
              </thead>
              {value === 'education' ? (
                <div className="table-data p-3">
                  <tr style={{ color: '#680000  ' }}>(2022) 📆</tr>
                  <tr>BSc in CSE</tr>
                  <tr>CGPA: 3.78 out of 4.00</tr>
                  <tr>International Islamic University Chittagong</tr>
                  <tr>Bangladesh</tr>
                  <tr style={{ color: '#680000  ' }}>Thesis🧾</tr>
                  <tr>Thesis was based on ML&NLP about 19000+ words</tr>
                  <tr>Published by IEEE</tr>
                </div>
              ) : (
                ''
              )}
              {value === 'experience' ? (
                <div className="table-data p-3">
                  <tr style={{ color: '#680000 ' }}>1.5+ year 📆</tr>
                  <tr>MERN stack Development</tr>
                  <tr>React.js*</tr>
                  <tr style={{ color: '#680000 ' }}>1+ year 📆</tr>
                  <tr>Research based on</tr>
                  <tr>Natural Language Processing</tr>
                  <tr style={{ color: '#680000 ' }}>(2021-2022) 📆</tr>
                  <tr>Teaching Assistant</tr>
                  <tr>Dept. of CSE, IIUC</tr>
                  <tr style={{ color: '#680000 ' }}>2+ year 📆</tr>
                  <tr>Competitive problem solving</tr>
                </div>
              ) : (
                ''
              )}
              {value === 'achievements' ? (
                <div className="table-data p-3">
                  <tr>
                    <a
                      href="https://scholar.google.com/citations?hl=en&user=3Fy31SgAAAAJ"
                      rel="noreferrer"
                      target="_blank"
                    >
                      ✒️ Research & Publications{' '}
                      <i class="bi bi-box-arrow-up-right"></i>
                    </a>
                  </tr>
                  <br />
                  <tr style={{ color: '#680000' }}>Math Olympiad 🧮</tr>
                  <tr>
                    I was one of the three lucky students to be selected among
                    all the students of our department to participate in the
                    11th national undergraduate mathematics Olympiad-2019.
                  </tr>

                  <tr style={{ color: '#680000' }}>Programing Contest 👨🏽‍💻</tr>
                  <tr>Ranked 9th in IIUC IUPC 2019</tr>
                  <tr>Participated in all the contests regularly(2019-2020)</tr>
                </div>
              ) : (
                ''
              )}
            </table>
          </div>
          <div className="passport-image col-sm-5">
            {/* <img
              // src="assets/Image_without_bg.png"
              src="assets/Image_without_bg.png"
              alt="pic"
              style={{ height: 'auto', width: '100%' }}
            /> */}
            <Lottie animationData={aboutAnimation} loop={true} />
          </div>
        </div>
      </div>
    </div>
  );
}
